<template>
  <Teleport to="body">
    <Transition name="confirm-overlay">
      <div
        v-if="visible"
        class="nickname-mask confirm-dialog-mask"
        role="presentation"
        @click.self="onCancel"
      >
        <div
          ref="dialogEl"
          class="nickname-modal ban-confirm-modal confirm-dialog-panel"
          role="alertdialog"
          aria-modal="true"
          :aria-labelledby="titleId"
          :aria-describedby="descId"
          @click.stop
        >
          <p v-if="eyebrow" class="ban-confirm-eyebrow">{{ eyebrow }}</p>
          <h2 :id="titleId" class="nickname-title ban-confirm-title">{{ title }}</h2>
          <p :id="descId" class="nickname-desc ban-confirm-desc">{{ message }}</p>
          <div class="nickname-actions">
            <button
              ref="cancelBtn"
              type="button"
              class="btn-light"
              @click="onCancel"
            >
              {{ cancelText }}
            </button>
            <button
              ref="confirmBtn"
              type="button"
              class="btn-outline"
              :class="{ danger: tone === 'danger' }"
              @click="onConfirm"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { registerConfirmDialogHost } from '../utils/confirmDialog'

let dialogSeq = 0

export default {
  name: 'ConfirmDialogHost',
  data() {
    return {
      visible: false,
      title: '确认操作',
      message: '',
      eyebrow: 'CONFIRM',
      confirmText: '确定',
      cancelText: '取消',
      tone: 'default',
      titleId: 'confirm-dialog-title',
      descId: 'confirm-dialog-desc',
      pendingResolve: null
    }
  },
  mounted() {
    registerConfirmDialogHost(this)
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeUnmount() {
    registerConfirmDialogHost(null)
    window.removeEventListener('keydown', this.onKeydown)
    this.finish(false)
  },
  methods: {
    open(options = {}) {
      if (this.pendingResolve) {
        this.pendingResolve(false)
        this.pendingResolve = null
      }
      dialogSeq += 1
      const seq = dialogSeq
      this.titleId = `confirm-dialog-title-${seq}`
      this.descId = `confirm-dialog-desc-${seq}`
      this.title = options.title || '确认操作'
      this.message = options.message || ''
      this.eyebrow = options.eyebrow || 'CONFIRM'
      this.confirmText = options.confirmText || '确定'
      this.cancelText = options.cancelText || '取消'
      this.tone = options.tone === 'danger' ? 'danger' : 'default'
      this.visible = true
      return new Promise((resolve) => {
        this.pendingResolve = resolve
        this.$nextTick(() => {
          this.$refs.confirmBtn?.focus()
        })
      })
    },
    onConfirm() {
      this.finish(true)
    },
    onCancel() {
      this.finish(false)
    },
    finish(result) {
      if (!this.visible && !this.pendingResolve) {
        return
      }
      this.visible = false
      const resolve = this.pendingResolve
      this.pendingResolve = null
      resolve?.(result)
    },
    onKeydown(event) {
      if (!this.visible) {
        return
      }
      if (event.key === 'Escape') {
        event.preventDefault()
        this.onCancel()
        return
      }
      if (event.key === 'Enter' && document.activeElement === this.$refs.cancelBtn) {
        return
      }
      if (event.key === 'Enter') {
        event.preventDefault()
        this.onConfirm()
      }
    }
  }
}
</script>

<style>
.confirm-dialog-mask {
  z-index: 10030;
}

.confirm-dialog-panel {
  width: min(420px, 94vw);
  border-radius: 14px;
  box-shadow:
    0 24px 64px rgba(0, 0, 0, 0.2),
    0 0 0 1px rgba(255, 255, 255, 0.45) inset;
}

.confirm-overlay-enter-active,
.confirm-overlay-leave-active {
  transition: opacity 0.34s ease;
}

.confirm-overlay-enter-active .confirm-dialog-panel,
.confirm-overlay-leave-active .confirm-dialog-panel {
  transition:
    transform 0.42s var(--bezier, cubic-bezier(0.15, 0.85, 0.35, 1)),
    opacity 0.42s var(--bezier, cubic-bezier(0.15, 0.85, 0.35, 1));
}

.confirm-overlay-enter-from,
.confirm-overlay-leave-to {
  opacity: 0;
}

.confirm-overlay-enter-from .confirm-dialog-panel,
.confirm-overlay-leave-to .confirm-dialog-panel {
  transform: translateY(22px) scale(0.962);
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .confirm-overlay-enter-active,
  .confirm-overlay-leave-active,
  .confirm-overlay-enter-active .confirm-dialog-panel,
  .confirm-overlay-leave-active .confirm-dialog-panel {
    transition-duration: 0.01ms;
  }
}
</style>
